// ** React Imports
import { useState } from 'react';
import CustomTable from '@myComponents/CustomTable';
import { ListEpisodes } from '../../../../graphql/Query/roads';
import { DeleteEpisode, DuplicateEpisode } from '../../../../graphql/Mutation/roads';
import { useMutation, useQuery } from '@apollo/client';
import { columns } from './columns';
import { handleConfirmCancel, handleConfirmDuplicate, handleError } from '@components/toast';
import { useNavigate } from 'react-router-dom';
import { _activities } from '../../../../hooks/useOptions';
import UploadDataCenterMasiveForm from '@components/MasiveUpload/MasiveUpload';
import Sidebar from '@components/sidebar';

const variables = {
  search: {
    activity: '',
    status: 'EMPTY',
    q: '',
    perPage: 10,
    page: 1
  }
};

const EpisodesList = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { data, refetch, loading } = useQuery(ListEpisodes, {
    variables
  });
  const navigate = useNavigate();
  const [deleteById] = useMutation(DeleteEpisode);
  const [handleDuplicateEpisode] = useMutation(DuplicateEpisode);
  
  const toggleSidebar = () => {
    navigate('/roads/episodes/new');
  };

  const handleDelete = async (episodeId) => {
    handleConfirmCancel('delete', true, async () => {
      try {
        await deleteById({ variables: { episodeId } });
        refetch();
      } catch (e) {
        handleError(e);
        throw e;
      }
    });
  };

  const duplicateEpisode = async (data) => {
    handleConfirmDuplicate(true, async () => {
      try {
        await handleDuplicateEpisode({ variables: { episodeId : data._id } });
        refetch();
      } catch (e) {
        handleError(e);
        throw e;
      }
    });
  };

  return (
    <>
      <CustomTable
        loading={loading}
        store={data?.listEpisodes?.docs || []}
        data={{ ...data?.listEpisodes, docs: undefined }}
        refetch={refetch}
        headerOptions={{
          type: 'add',
          name: 'Crear Episodio',
          handle: () => {
            toggleSidebar();
          }
        }}
        headerOptionsModal={{
          type: 'add',
          name: 'Carga Masiva',
          handle: () => {
            setSidebarOpen(true);
          }
        }}
        filterOptions={{
          types: [
            {
              id: 'road_activity',
              name: 'activity',
              options: 'activitiesOptions',
              type: 'select'
            },
            {
              id: 'road_status',
              name: 'status',
              options: 'statusOptions',
              type: 'select'
            }
          ]
        }}
        variables={variables}
        columns={columns({ _data: _activities, handleDelete, navigate, duplicateEpisode})}
      />
      <Sidebar
        size="lg"
        open={sidebarOpen}
        title={'Editar Logro'}
        headerClassName="mb-1"
        contentClassName="pt-0"
        toggleSidebar={() => {
          setSidebarOpen(!sidebarOpen);
        }}
        onClosed={() => {}}
      >
        {sidebarOpen && (
          <UploadDataCenterMasiveForm
            open={sidebarOpen}
            type="episodios" 
            toggleSidebar={() => {
              setSidebarOpen(!sidebarOpen);
            }}
            refetch={() => {}}
          />
        )}
      </Sidebar>
    </>
  );
};

export default EpisodesList;
